<template>
  <div class="pdc-container">
    <div class="title-container" @click="openPdcDetails = !openPdcDetails">
      <p class="title d-flex justify-content-between">
        {{ $t('pdc.title') }}
        <span class="icon">
          <b-icon-chevron-down v-if="!openPdcDetails" />
          <b-icon-chevron-up v-else />
        </span>
      </p>
      <p class="desc">
        {{ $t('pdc.desc') }}
      </p>
    </div>

    <!-- expanded view -->
    <div class="main-container" v-show="openPdcDetails">
      <div class="sub-container">
        <p class="label">
          {{ $t('pdc.pay') }}
          <span
            @click="openPayLearnMore = !openPayLearnMore"
            class="learn-more"
            >{{ $t('pdc.learnMore') }}</span
          >
        </p>
        <div v-if="openPayLearnMore" class="learn-more-expanded">
          <p class="text">
            {{ $t('pdc.payDesc') }}
          </p>
        </div>
        <p class="value">{{ $t('pdc.payValue') }}</p>
      </div>
      <div class="sub-container">
        <p class="label">{{ $t('pdc.invAmtLabel') }}</p>
        <p class="value">₹{{ amount }}</p>
      </div>
      <div class="sub-container">
        <p class="label">{{ $t('pdc.invAmtWordsLabel') }}</p>
        <p class="value">{{ words }}</p>
      </div>
      <div class="sub-container">
        <p class="label">
          {{ $t('pdc.date') }}
          <span
            @click="openDateLearnMore = !openDateLearnMore"
            class="learn-more"
            >{{ $t('pdc.learnMore') }}</span
          >
        </p>
        <div v-if="openDateLearnMore" class="learn-more-expanded">
          <p class="text">
            {{ $t('pdc.dateDesc') }}
          </p>
        </div>
        <p class="value">{{ computedDate }}</p>
      </div>
      <div class="sub-container">
        <p class="label">{{ $t('pdc.sampleCheque') }}</p>
        <img
          @click="openSampleCheque = true"
          class="value"
          src="@/assets/images/common/pdc-sample-cheque.png"
        />
      </div>
    </div>

    <!-- cheque modal -->
    <b-modal
      v-model="openSampleCheque"
      hide-header
      centered
      hide-footer
      size="xl"
    >
      <div class="pdc-cheque-container">
        <img
          class="pdc-cheque"
          src="@/assets/images/common/pdc-sample-cheque.png"
        />
        <img
          @click="openSampleCheque = false"
          class="close-btn"
          src="@/assets/images/common/cross.svg"
        />
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: {
    amount: {
      type: String,
      required: false,
      default: ''
    },
    date: {
      type: String,
      required: false,
      default: ''
    },
    words: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      openPayLearnMore: false,
      openDateLearnMore: false,
      openPdcDetails: true,
      openSampleCheque: false
    }
  },
  computed: {
    computedDate() {
      return this.date && this.date.split('-').reverse().join('/')
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';

.pdc-container {
  font-family: $nunito;
  border-radius: 4px;
  overflow: hidden;

  p {
    margin: 0;
  }

  .title-container {
    cursor: pointer;
    background-color: $light-blue-background-color;
    padding: 16px;

    .title {
      font-size: 20px;
      color: $secondary;
      font-weight: 700;
      margin-bottom: 8px;
    }
    .desc {
      font-size: 14px;
    }
  }

  .main-container {
    padding: 16px;
    background-color: white;

    .sub-container {
      margin-bottom: 25px;
      .label {
        font-size: 16px;
        font-weight: 400;
        color: $secondary;
        margin-bottom: 6px;

        .learn-more {
          text-decoration: underline;
          color: $primary;
          cursor: pointer;
        }
      }

      .learn-more-expanded {
        border-radius: 4px;
        padding: 14px;
        border: 1px solid $table-border-color;
        margin-bottom: 6px;

        .text {
          padding-left: 12px;
          border-left: 3px solid $secondary;
        }
      }

      .value {
        cursor: pointer;
        font-size: 18px;
        font-weight: 400;
        max-width: 100%;
      }
    }
  }
}

.pdc-cheque-container {
  width: 100%;
  height: fit-content;
  padding: 22px 12px 22px;
  position: relative;

  .pdc-cheque {
    width: 100%;
    max-width: 100%;
    height: auto;
  }

  .close-btn {
    cursor: pointer;
    position: absolute;
    height: 20px;
    width: auto;
    top: 0;
    right: 0;
  }
}
</style>
